<template>
  <Layout
    class="onboarding-books onboarding-books--done"
    title="We added the books you like to your <span>Custom Library!</span>"
  >
    <template #aboveTitle>
      <div class="onboarding-books__covers">
        <div
          v-for="(book, index) in books"
          :key="book.id"
          class="onboarding-books__cover-wrapper"
          :style="{ '--book-index': index }"
        >
          <img
            :src="getImage(`${book.id}.png`)"
            width="223"
            height="298"
            alt=""
            class="onboarding-books__cover"
          />
        </div>
      </div>
    </template>
  </Layout>
</template>

<script setup lang="ts">
import { computed, onBeforeMount } from 'vue'

import type { BooksChoice } from '@/models/onboarding.types'
import { getImage, QuestionnaireView } from '@/models/onboarding'

import Layout from './Layout.vue'

const props = defineProps<{
  view: QuestionnaireView
}>()

const books = computed(() => {
  const allBooks = props.view.currentChoice as BooksChoice | undefined
  if (!allBooks) {
    return []
  }

  return allBooks.filter((book) => book.score >= 0)
})

onBeforeMount(() => {
  props.view.showContinueButton()
})
</script>

<style lang="scss" scoped>
.onboarding-books {
  gap: var(--onboarding-padding);

  :deep(.onboarding-layout__above-title),
  :deep(.onboarding-layout__text) {
    flex: 1;
  }

  :deep(.onboarding-layout__above-title) {
    display: flex;
    align-items: center;
  }

  &__covers {
    position: relative;
    z-index: 0;
    display: flex;
    justify-content: space-around;
    width: 100%;
    margin: auto;
  }

  &__cover-wrapper {
    min-width: 0;
    z-index: calc(10 - var(--book-index));

    &:last-child {
      min-width: auto;
    }
  }

  &__cover {
    width: 144px;
    max-width: none;
    filter: drop-shadow(0px 1px 5px rgba(255, 255, 255, 0.1))
      drop-shadow(0px 8px 15px rgba(20, 28, 49, 0.1));
  }
}
</style>
